// extracted by mini-css-extract-plugin
export default {"background":"Hero_background__p5jkB","headline":"Hero_headline__t7Y4Q"};